var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1567 1.61187C17.7082 0.501789 19.2918 0.501787 19.8433 1.61187L24.3478 10.6779C24.5662 11.1175 24.9859 11.4224 25.4715 11.4943L35.4857 12.9767C36.7119 13.1583 37.2013 14.6643 36.316 15.5319L29.0856 22.6175C28.735 22.961 28.5747 23.4544 28.6564 23.9384L30.3411 33.9207C30.5474 35.1429 29.2662 36.0737 28.1675 35.4998L19.1945 30.8129C18.7594 30.5857 18.2406 30.5857 17.8055 30.8129L8.83246 35.4998C7.73376 36.0737 6.45263 35.1429 6.65891 33.9207L8.34358 23.9384C8.42527 23.4544 8.26496 22.961 7.91438 22.6175L0.684045 15.5319C-0.20127 14.6643 0.288074 13.1583 1.51427 12.9767L11.5285 11.4943C12.0141 11.4224 12.4338 11.1175 12.6522 10.6779L17.1567 1.61187Z",
    fill: "#FCD503"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStar);
export default __webpack_public_path__ + "static/media/googleStar.43a8e1e690f2604d76edcae24c48e5e6.svg";
export { ForwardRef as ReactComponent };